import { render, staticRenderFns } from "./THGUserAutoComplete.vue?vue&type=template&id=31712c4d"
import script from "./THGUserAutoComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUserAutoComplete.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports